import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import RCore from 'RCore';
import { styledUI } from '../../StyledUI';

//These lines are needed to get common i18
//const i18Common = require('../../../../i18/i18.Common');
//const i18 = RCore.getTranslation.bind({ dict: i18Common });

const SkewContainer = styled.ul`
    transform: skew(-${props => props.theme.skins.skew.angle}deg);
    padding: 15px 0px 0;
`;

const LIList = styled.li`
    position: relative;
    display: flex;
    padding: 0;
    font-size: 30px;
    line-height: 20px;
    align-items: center;
    z-index: 2;
    margin-bottom: 3px;
    text-transform: uppercase;
    color: ${props => props.theme.color};

    & > * {
        z-index: 2;
    }

    &.scew-header {
        padding-bottom: 3px;
    }

    > * {
        display: flex;
        min-height: 64px;
        background-color: ${props => props.theme.content.accentColor};
        color: ${props => props.theme.content.accentTextColor};
        align-items: center;
        justify-content: center;

        &.tl-rank {
            border: 1px solid ${props => props.theme.content.accentTextColor};
        }

        &.list-player-name,
        &.tl-image {
            background-color: ${props => props.theme.content.backgroundColor};
        }

        &.tl-score {
            border: 1px solid ${props => props.theme.content.accentTextColor};
            min-width: 60px;
            padding: 0 5px;
        }
    }

    .tl-rank,
    .tl-rank {
        width: 60px;
        min-width: 60px;
        > * {
            transform: skew(${props => props.theme.skins.skew.angle}deg);
        }
    }

    .tl-image {
        margin: 0 2px;
        width: 60px;
        min-width: 60px;
        overflow: hidden;
        display: flex;
        align-items: flex-end;

        > * {
            transform: skew(${props => props.theme.skins.skew.angle}deg);
        }
    }

    .list-player-name {
        line-height: 1em;
        flex-grow: 1;
        overflow: hidden;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        z-index: 3;

        padding-left: 14px;
        justify-content: flex-start;

        > span {
            transform: skew(${props => props.theme.skins.skew.angle}deg);
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
        }
    }

    .tl-score {
        margin-left: 2px;
        white-space: nowrap;
        position: relative;
        z-index: 3;

        > span {
            transform: skew(${props => props.theme.skins.skew.angle}deg);
        }
    }

    .tl-unit {
        font-size: 22px;
    }

    &.pls_highlight {
        .tl-image,
        .list-player-name {
            background-color: ${props => props.theme.content.accentColor};
            color: ${props => props.theme.color};
        }
    }
`;

const Header = () => {
    return <div />;
};

const Row = withTheme(({ theme, player, seasonId, rank, highlightFirstPlayer, highlightTeam, ...props }) => {
    var name = RCore.getFirstLastName(player.name);
    const SMPlayerLogo = styledUI.getCustomComponentFromTheme(theme, 'playerLogo', props);

    return (
        <LIList
            key={player.id}
            className={highlightFirstPlayer || highlightTeam === player.teamId ? 'pls_highlight' : ''}
        >
            <div className="tl-rank">
                <span>{rank + 1}</span>
            </div>
            <div className="tl-image">
                <SMPlayerLogo
                    playerId={player.id}
                    teamId={player.teamId}
                    seasonId={seasonId}
                    width={60}
                    height={60}
                    number={player.shirtNumber}
                />
            </div>
            <div className="list-player-name">
                <span>
                    {name.firstName} <b>{name.lastName}</b>
                </span>
            </div>
            <div className="tl-score">
                <span>{player.displayValue || player.value}</span>
            </div>
        </LIList>
    );
});

Header.contextTypes = {
    info: PropTypes.object
};

Row.contextTypes = {
    info: PropTypes.object
};

const Container = ({ children }) => <SkewContainer>{children}</SkewContainer>;

export default { Header, Row, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/lists/SkewPlayerList.js
 **/